import React from 'react';
import Icon from '../../../components/AppIcon';

const MediaMonitoring = () => {
  const mentions = [
    {
      id: 1,
      source: 'TechCrunch',
      title: 'The Future of Digital Publishing: A Deep Dive',
      excerpt: 'PenGame Publishing continues to innovate in the digital space with their latest AI-powered content creation tools...',
      sentiment: 'positive',
      timestamp: '3 hours ago',
      reach: '2.5M',
      engagement: '1.2K',
      url: 'https://techcrunch.com/article-example'
    },
    {
      id: 2,
      source: 'Publishers Weekly',
      title: 'Industry Spotlight: Rising Stars in Publishing',
      excerpt: 'Among the notable mentions this week, PenGame Publishing has been making waves with their comprehensive PR platform...',
      sentiment: 'positive',
      timestamp: '1 day ago',
      reach: '850K',
      engagement: '456',
      url: 'https://publishersweekly.com/article-example'
    },
    {
      id: 3,
      source: 'BookBusiness Magazine',
      title: 'Technology Trends Shaping Modern Publishing',
      excerpt: 'The integration of AI tools in publishing workflows has shown mixed results, with some concerns about authenticity...',
      sentiment: 'neutral',
      timestamp: '2 days ago',
      reach: '320K',
      engagement: '89',
      url: 'https://bookbusiness.com/article-example'
    },
    {
      id: 4,
      source: 'Literary Review Blog',
      title: 'Author Marketing in the Digital Age',
      excerpt: 'While platforms like PenGame offer comprehensive solutions, authors should be cautious about over-relying on automation...',
      sentiment: 'mixed',
      timestamp: '3 days ago',
      reach: '125K',
      engagement: '234',
      url: 'https://literaryreview.com/article-example'
    }
  ];

  const getSentimentColor = (sentiment) => {
    switch (sentiment) {
      case 'positive': return 'text-success bg-success/10';
      case 'negative': return 'text-error bg-error/10';
      case 'neutral': return 'text-muted-foreground bg-muted';
      case 'mixed': return 'text-warning bg-warning/10';
      default: return 'text-muted-foreground bg-muted';
    }
  };

  const getSentimentIcon = (sentiment) => {
    switch (sentiment) {
      case 'positive': return 'TrendingUp';
      case 'negative': return 'TrendingDown';
      case 'neutral': return 'Minus';
      case 'mixed': return 'BarChart3';
      default: return 'Minus';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <h2 className="text-lg font-semibold text-foreground">Media Monitoring</h2>
          <div className="flex items-center space-x-1 px-2 py-1 bg-success/10 text-success rounded-full">
            <Icon name="Circle" size={6} className="fill-current" />
            <span className="text-xs font-medium">Live</span>
          </div>
        </div>
        <button className="text-sm text-primary hover:text-primary/80 font-medium">
          View Full Report
        </button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <div className="text-center p-4 bg-muted/50 rounded-lg">
          <div className="text-2xl font-bold text-foreground mb-1">24</div>
          <div className="text-xs text-muted-foreground">Mentions This Week</div>
        </div>
        <div className="text-center p-4 bg-muted/50 rounded-lg">
          <div className="text-2xl font-bold text-success mb-1">85%</div>
          <div className="text-xs text-muted-foreground">Positive Sentiment</div>
        </div>
        <div className="text-center p-4 bg-muted/50 rounded-lg">
          <div className="text-2xl font-bold text-primary mb-1">3.8M</div>
          <div className="text-xs text-muted-foreground">Total Reach</div>
        </div>
      </div>
      <div className="space-y-4">
        {mentions?.map((mention) => (
          <div key={mention?.id} className="border border-border rounded-lg p-4 hover:shadow-sm transition-shadow duration-200">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-muted rounded-lg">
                  <Icon name="Globe" size={16} className="text-muted-foreground" />
                </div>
                <div>
                  <h3 className="text-sm font-medium text-foreground">{mention?.source}</h3>
                  <p className="text-xs text-muted-foreground">{mention?.timestamp}</p>
                </div>
              </div>
              <div className={`flex items-center space-x-1 px-2 py-1 rounded-full ${getSentimentColor(mention?.sentiment)}`}>
                <Icon name={getSentimentIcon(mention?.sentiment)} size={12} />
                <span className="text-xs font-medium capitalize">{mention?.sentiment}</span>
              </div>
            </div>
            
            <h4 className="text-sm font-medium text-foreground mb-2">{mention?.title}</h4>
            <p className="text-xs text-muted-foreground mb-3 line-clamp-2">{mention?.excerpt}</p>
            
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="flex items-center space-x-1">
                  <Icon name="Eye" size={12} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">{mention?.reach}</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Icon name="MessageCircle" size={12} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">{mention?.engagement}</span>
                </div>
              </div>
              <button className="text-xs text-primary hover:text-primary/80 font-medium flex items-center space-x-1">
                <span>Read Full Article</span>
                <Icon name="ExternalLink" size={12} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MediaMonitoring;